export default "__VITE_ASSET__CRYN2fqi__"